import common from './common.json'
import developer from './developer.json'
import landing from './landing.json'
import header from './header.json'
import footer from './footer.json'
import auditor from './auditor.json'
import trader from './trader.json'
import government from './government.json'
import help from './help.json'
import auth from './auth.json'

export default {
  common,
  developer,
  landing,
  header,
  footer,
  auditor,
  trader,
  government,
  help,
  auth
} as const